import React, {Component} from "react";
import {Link} from "react-router";
import ConfigService from "../service/ConfigService";

class MarketingLink extends Component {
    render() {
        const fullyQualifiedUrl = ConfigService.marketingHomeUrl +
            (this.props.href.substr(0, 1) === '/' ? '' : '/') +
            this.props.href;

        const className = this.props.small && 'small';

        return (
            <Link
                className={className}
                href={fullyQualifiedUrl}
                target="_blank">{
                this.props.icon && <i className={`m-l-xs m-r-xs icon icon-${this.props.icon}`}/>}
                {this.props.children}</Link>
        );
    }
}

export default MarketingLink;



// WEBPACK FOOTER //
// ./src/modules/common/MarketingLink.js